import React from 'react';

import Spinner from './Spinner';
import { getLocale, LocaleProvider } from './locales';
import { useBrandedDocTitle } from './utils';
import { BrandingDataProvider } from './dataProviders';
import useLayout from './useLayout';
import { makeBtStyles, Theme } from './Theme';


import { OrderStateProvider, useOrderState } from './returns/useFindOrder';
import { ReturnLabelStateProvider, useReturnLabelState } from './returns/useCreateReturn';
import FindOrderForm from './returns/FindOrderForm';
import ConfigureReturn from './returns/ConfigureReturn';
import ReturnConfirmation from './returns/ReturnConfirmation';
import { useLoadPortalConfig } from './returns/useLoadPortalConfig';


const useStyles = makeBtStyles( (theme: Theme ) => ({
  card: {
    padding: '40px',
    margin: '50px auto',
    ...theme.card
  }
}));


export const getReturnsCenterIdFromUrl = () => {
  const url = new URL(window.location.href);
  const id = url.searchParams.get('id');
  if( !id ) {
    throw new Error('Missing return ID');
  }
  return id;
};


export default function Returns() {
  const locale = getLocale();
  const returnsCenterId = getReturnsCenterIdFromUrl();
  const { branding } = useLoadPortalConfig(returnsCenterId);

  const Layout = useLayout(branding);

  useBrandedDocTitle(branding);

  if( !returnsCenterId ) {
    return "";
  }
  
  if( !branding ) {
    return <Spinner />;
  }

  return <LocaleProvider locale={locale}>
    <BrandingDataProvider value={branding}>
      <OrderStateProvider>
        <ReturnLabelStateProvider>
          <Layout.Layout>
            <ReturnsPage />
          </Layout.Layout>
        </ReturnLabelStateProvider>
      </OrderStateProvider>
    </BrandingDataProvider>
  </LocaleProvider>;
}

const ReturnsPage = () => {
  const classes = useStyles();
  const { order } = useOrderState();
  const { returnRecord } = useReturnLabelState();

  return !order ? (
    <FindOrderForm className={classes.card} />
  ):( (!returnRecord) ? (
    <ConfigureReturn className={classes.card} />
  ):(
    <ReturnConfirmation className={classes.card} />
  ))
}